if (!customElements.get('product-tabs')) {

    class ComponentProductTabs extends HTMLElement {
        constructor() {

            super();
            this.id = this.dataset.id;
            this.sliderWrapper = this.querySelector('.keen-slider');
            this.carousel = null;
            this.currentSlide = 0;
            this.initAccordion('.accordion-' + this.id, true);
            this.initReadMore();
            if(this.amount){
                this.amount.innerHTML = this.currentSlide+'/'+this.slides.length;
            }
            if(this.sliderWrapper){
                this.initCarousel()
            }
        }

        initCarousel() {  
            this.carousel = new KeenSlider(this.sliderWrapper, {
                mode: "free-snap",
                loop: false,
                autoplay: false,
                dots: this.sliderWrapper.querySelector('.keen-dots') ? this.sliderWrapper.querySelector('.keen-dots') : false,
                prevButton: this.querySelector('.keen-arrow.prev') || false,
                nextButton: this.querySelector('.keen-arrow.next') || false,
                slidesPerView: 1
            });        
        }

        initReadMore() {
            var that = this;
            var btnsShowMore = this.querySelectorAll('.showmore');
            btnsShowMore.forEach((btnShowMore, b) => {
                btnShowMore.addEventListener('click', e => {
                    e.preventDefault();
                    var remaining = btnShowMore.parentNode.querySelector('.remaining');
                    if (remaining) {
                        if (remaining.classList.contains('active')) {
                            remaining.classList.remove('active');
                            btnShowMore.innerHTML = btnShowMore.getAttribute('data-label');
                        } else {
                            remaining.classList.add('active');
                            btnShowMore.setAttribute('data-label', btnShowMore.innerHTML);
                            btnShowMore.innerHTML = 'Hide Ingredients';
                        }
                    }
                });
            });
        }

        initAccordion(elem, option) {
            document.addEventListener('click', e => {
                if ((!e.target.matches(elem + ' .tab-btn'))) { 
                    return
                }else {
                    if (!e.target.parentElement.classList.contains('active')) {
                        if (option == true) {
                            var elementList = document.querySelectorAll(elem + ' .tab-container');
                            Array.prototype.forEach.call(elementList, function (e) {
                                e.classList.remove('active');
                            });
                        }
                        e.target.parentElement.classList.add('active');
                    } else {
                        e.target.parentElement.classList.remove('active');
                    }
                }
            });
        }
    }

    customElements.define('product-tabs', ComponentProductTabs);
}